<template>
	<div>
        <Loading :value="loading" ></Loading>

          <!--  MODAL VALIDATION MISSION-->
            <v-dialog v-model="dialogDetail" transition="dialog-bottom-transition" scrollable :loading="loading" fullscreen hide-overlay>
                <v-card>
                    <v-toolbar card dark color="primary">
                        <v-toolbar-title>Fiche de Validation de la commande {{detailCommande.ref}}{{detailCommande.libele}}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn icon dark @click.native="closeDialog()">
                            <v-icon>close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout>
                            <v-flex>
                                <v-card color="" class="mb-5" flat >
                                    <v-layout wrap>
                                        <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Informations générales
                                            </v-alert>

                                            <v-card flat>

                                                <v-layout wrap>

                                                    <v-card-text>

                                                        <v-flex xs12>
                                                            <v-flex xs12 class="text-xs-left"> <!--HAUT-->
                                                                <v-layout row>
                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                        <v-layout row>
                                                                            <v-flex xs2>Projet</v-flex>
                                                                            <v-flex xs10 class="text-xs-right title">
                                                                                {{detailCommande.projet}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs2>Chantier</v-flex>
                                                                            <v-flex xs10 class="text-xs-right title">
                                                                                {{detailCommande.chantier}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs2>Travaux</v-flex>
                                                                            <v-flex xs10 class="text-xs-right title">
                                                                                {{detailCommande.travaux}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row>
                                                                            <v-flex xs2>Tâche</v-flex>
                                                                            <v-flex xs10 class="text-xs-right title">
                                                                                {{detailCommande.tache}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                    </v-flex>

                                                                    <v-flex xs6 class="mr-4"> <!--COLONNE 1-->
                                                                    <v-layout row>
                                                                            <v-flex xs6>Fournisseur</v-flex>
                                                                            <v-flex xs6 class="text-xs-left title">
                                                                                {{detailCommande.fournisseurNom}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                        <v-layout row>
                                                                            <v-flex xs6>Date commande</v-flex>
                                                                            <v-flex xs6 class="text-xs-left title">
                                                                                {{detailCommande.dateC}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>

                                                                        <v-layout row>
                                                                            <v-flex xs6>Date de la livraison</v-flex>
                                                                            <v-flex xs6 class="text-xs-left title">
                                                                                {{detailCommande.dateLivr}}
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider class="mb-3"></v-divider>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                        </v-flex>
                                                    </v-card-text>


                                                </v-layout>
                                            </v-card>

                                        </v-flex>
                                     <v-flex xs12 >
                                            <v-alert  :value="true" outline color="purple" icon="info">
                                                Ressources
                                            </v-alert>
                                            <v-card color="" class="mb-5" >
                                                <v-card-text>
                                                    <v-layout wrap>
                                                        <v-flex xs12>
                                                            <v-card>
                                                                 <v-flex xs12   >
                                                                    <v-chip style="font-size:20px" label outline color="green"><b>Total (TTC): {{new Intl.NumberFormat().format(detailCommande.totalN)}}</b></v-chip>
                                                                </v-flex>
                                                                <v-layout row>
                                                                     <template>
                                                                        <el-table :data="detailCommande.option" height="250" style="width: 100%">
                                                                            <el-table-column prop="codeAnalytique" label="Code analytique" width="180"></el-table-column>  
                                                                            <el-table-column prop="produit" label="Ressource" width="180"></el-table-column>  
                                                                            <el-table-column prop="prix" label="Prix unitaire (FCFA)"></el-table-column>
                                                                            <el-table-column prop="unite" label="Unité"></el-table-column>
                                                                            <el-table-column prop="qte" label="Quantité"></el-table-column>
                                                                            <el-table-column prop="total" label="Total TTC (FCFA)"></el-table-column>
                                                                        </el-table>
                                                                    </template>
                                                                </v-layout>
                                                                <br>
                                                            </v-card>
                                                        </v-flex>
                                                    </v-layout>
                                                </v-card-text>
                                            </v-card>
                                        </v-flex>

                                    </v-layout>
                                </v-card>
                            </v-flex>
                        </v-layout>
                    </v-card-text>

                    <div style="flex: 1 1 auto;"></div>



                </v-card>

                <v-tooltip top>
                    <v-btn class="mb-5" style="margin-right: 100px"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="red"
                           @click="dialogConfirmRefus = true"
                    >
                        <v-icon>close</v-icon>
                    </v-btn>
                    <span>Rejeter la commande</span>
                </v-tooltip>



                <v-tooltip top>
                    <v-btn class="mb-5 ml-5"
                           absolute
                           slot="activator"
                           dark
                           fab
                           large
                           bottom
                           right
                           color="green"
                           @click="dialogConfirm = true"
                    >
                        <v-icon>done</v-icon>
                    </v-btn>
                    <span>Valider la commande</span>
                </v-tooltip>
            </v-dialog>
            <!-- FIN MODAL VALIDATION MISSION-->






         <!-- CONFIRMATION REFUS DEMANDE -->
         <v-layout row justify-center>
            <v-dialog v-model="dialogConfirmRefus" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation de la commande</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous Refuser ce devis ?"
                        :closable="false"
                        show-icon
                        type="error">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">COMMANDE REFERENCE</p>
                    <p class="black--text .font-weight-regular subheading" >{{detailCommande.ref}}</p>
                </v-flex>
                <v-flex xs12>
                    <el-form  id="formRefus" :rules="ruleFormRefus" ref="refFormRefust"  label-position="top" :inline="true" :model="formRefus" class="demo-form-inline">
                     <v-flex xs12 >
                        <el-form-item style="width:100%" label="Commentaire" prop="rapportRefus" >
                            <el-input style="width:100%"  type="textarea" :rows="6" placeholder="Pourquoi voulez-vous refuser ?" v-model="formRefus.rapport"></el-input>
                        </el-form-item >
                    </v-flex>
                    </el-form>
                </v-flex>

            </v-layout>

                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirmRefus = false">Annuler</v-btn>
                <v-btn color="red darken-1" dark @click.native="SubmitValideDevis('rejeter')">Refuser</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>

         <!-- CONFIRMATION VALIDATION -->
        <v-layout row justify-center>
            <v-dialog v-model="dialogConfirm" persistent max-width="650">
            <v-card>
                <v-card-title class="headline">Validation d'une commande</v-card-title>
                <v-card-text>
                    <v-layout wrap>
                    <v-flex xs12 class="mb-2">
                     <el-alert
                        title="Voulez vous valider le devis ?"
                        :closable="false"
                        show-icon
                        type="success">
                    </el-alert>
                </v-flex>
                <v-flex xs12>
                    <p class="grey--text font-weight-thin body-1">COMMANDE REFERENCE</p>
                    <p class="black--text .font-weight-regular subheading" >{{detailCommande.ref}}</p>
                </v-flex>
            </v-layout>

                    </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey darken-1" dark @click.native="dialogConfirm = false">Annuler</v-btn>
                <v-btn color="green darken-1" dark  @click.native="SubmitValideDevis('confirme')">Confirmer</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
         </v-layout>
	</div>
</template>


<script>
    import Loading from '@/components/Loading'
    export default {
	components:{ Loading },
        name: "ModalValidationDmdCom",
        props:["show","detailCommande","totalMontant"],
        data()
        {
         return {
            //data general
            domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
            user: JSON.parse(sessionStorage.getItem("userInfo")),
            roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
            droitAcces: JSON.parse(sessionStorage.getItem('sessionDroit')),
            loading: false,
            dialogDetail: false,
            dialogVisible: false,
            dialogConfirmRefus: false,
            dialogConfirm: false,
            formRefus:{},
             ruleFormRefus: {
                rapportRefus: [
                    { required: true, message: 'Veuillez saisir' },
                ],
            }
         }
        },

        computed:{

        },
         watch: {
            show : function(newValue, oldvalue){
               this.dialogDetail = newValue
               if(newValue == true){
                   //this.loadDevisConstat()
               }
            }
        },

        methods: {
             successNotif(mess = ""){
                this.$notify({
                        title: 'ENREGISTREMENT REUSSI',
                        message: mess,
                        type: 'success',
                        position: 'top-center'
                })
            },
            SubmitValideBudget(){

            },
             closeDialog(){
                this.$emit('close',this.detailCommande.IdUtil,"mission")
            },

             SubmitValideDevis(item){
               this.loading = true;
                let url = this.domaine + "validationDG/commande/valide";
                let data = new FormData()
                data.append("idComande", this.detailCommande.id)                
                data.append("user", this.user.id);
                data.append("etat", item);
                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                 this.dialogConfirm = false
                  this.closeDialog();

            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors de la validation de la mission")
            })
            },
             SubmitRefusDevis(){
                this.loading = true;
                let url = this.domaine + "mission/rejeter";
                var data = new FormData()
                data.append("motifRefus", this.formRefus.rapport)
                data.append("idMission", this.detailCommande.IdUtil)
                data.append("user", this.user.id);

                this.$http.post(url,data).then(response => {
                this.loading = false
                this.successNotif(response.body.message)
                 this.dialogConfirmRefus = false
                this.closeDialog();

            },errResp=>{
                 this.loading = false
                 this.$message.error("Une erreur est survenue lors du refus de la demande de mission")
            })
            }
        },
        mounted(){

        }

    }
    </script>



// WEBPACK FOOTER //
// src/components/validationDG/ModalValidationDmdCom.vue